import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
// Captured at module load, before MainApp strips deep-link params from the URL.
const initialSrc = new URLSearchParams(window.location.search).get('src');
const initialReferrer = document.referrer;

export const visitorId = () => {
  try {
    let id = localStorage.getItem('fbc_visitor_id');
    if (!id) {
      id = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem('fbc_visitor_id', id);
    }
    return id;
  } catch {
    return 'no-storage';
  }
};

// Session counter (one increment per browser session) — used for "2nd visit" prompts.
export const visitCount = () => {
  try {
    if (!sessionStorage.getItem('fbc_visit_counted')) {
      sessionStorage.setItem('fbc_visit_counted', '1');
      localStorage.setItem('fbc_visits', String((parseInt(localStorage.getItem('fbc_visits') || '0', 10) || 0) + 1));
    }
    return parseInt(localStorage.getItem('fbc_visits') || '1', 10) || 1;
  } catch {
    return 1;
  }
};

// ---- visible-time tracking for the current section ----
let current = null; // { section, projectId, visibleMs, since }
const projectSeconds = {}; // projectId -> seconds this session (for engagement prompts)

const flush = () => {
  if (!current) return;
  if (current.since) current.visibleMs += Date.now() - current.since;
  const seconds = Math.round(current.visibleMs / 1000);
  if (current.projectId) projectSeconds[current.projectId] = (projectSeconds[current.projectId] || 0) + seconds;
  if (seconds >= 2) {
    const auth = axios.defaults.headers.common?.Authorization;
    try {
      fetch(`${API}/api/analytics/time`, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', ...(auth ? { Authorization: auth } : {}) },
        body: JSON.stringify({ visitor_id: visitorId(), section: current.section, project_id: current.projectId, seconds }),
      }).catch(() => {});
    } catch { /* noop */ }
  }
  current.visibleMs = 0;
  current.since = document.visibilityState === 'visible' ? Date.now() : null;
};

document.addEventListener('visibilitychange', () => {
  if (!current) return;
  if (document.visibilityState === 'hidden') flush();
  else current.since = Date.now();
});
window.addEventListener('pagehide', flush);

export const secondsOnProject = (projectId) => {
  if (!projectId) return 0;
  const live = current && current.projectId === projectId && current.since ? (current.visibleMs + Date.now() - current.since) / 1000 : 0;
  return (projectSeconds[projectId] || 0) + live;
};

export const trackView = (section, projectId = null) => {
  flush();
  current = { section, projectId, visibleMs: 0, since: document.visibilityState === 'visible' ? Date.now() : null };

  let isLanding = false;
  try {
    isLanding = !sessionStorage.getItem('fbc_session_started');
    if (isLanding) sessionStorage.setItem('fbc_session_started', '1');
  } catch { /* noop */ }
  visitCount();
  axios.post(`${API}/api/analytics/track`, {
    visitor_id: visitorId(),
    section,
    project_id: projectId,
    is_landing: isLanding,
    src: isLanding ? initialSrc : null,
    referrer: isLanding ? initialReferrer : null,
    host: window.location.hostname,
  }).catch(() => {});
};
